<template>
	<div class="order_detail">
		<div class="card">
			<div class="title">{{type=='addMoney'?(isWorkerInscreasePay?'费用调整':'增加费用'):'订单支付'}}</div>
			<div class="base">
				<div class="header">
					<div class="left">
						<div class="name">{{title}}</div>
						<div class="status">状态：<span class="error">{{status_name}}</span></div>
					</div>
					<div class="right">
						<!--            <Button type="primary" size="small">修改订单</Button>-->
						<Button class="cancel" size="small" v-if="status < 4" @click="cancel()">取消订单</Button>
					</div>
				</div>
				<div class="info">
					<span>客户：{{nickname}}</span>
					<span>订单编号：{{order_no}}</span>
					<span>下单时间：{{created_at}}</span>
					<span v-if="end_date != ''">支付截止时间：{{end_date}}</span>
				</div>
			</div>
		</div>
		<div class="block"></div>
		<el-tabs v-if="type==''">
			<el-tab-pane>
				<span slot="label">支付信息</span>
				<div class="block"></div>
				<div class="user-info">
					<el-descriptions title="支付信息" :column="1">
						<el-descriptions-item label="订单费用" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{all_money||0}}
						</el-descriptions-item>
						<el-descriptions-item label="运费" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{logistics.freight||0}}
						</el-descriptions-item>
						<el-descriptions-item label="优惠券" v-if="formItem.coupon_price>0"
							label-class-name="descriptions-label"
							content-class-name="descriptions-label">-{{formItem.coupon_price||0 }}
						</el-descriptions-item>
						<el-descriptions-item label="最终费用" label-class-name="descriptions-label"
							content-class-name="descriptions-label"> <span class='text-red'>{{price||0}}</span>
						</el-descriptions-item>
					</el-descriptions>
				</div>

			</el-tab-pane>
		</el-tabs>
		<div class="block"></div>
		<div class="padding wn60" v-if="type=='addMoney'">
			<Form class="form" :label-width="80" label-position="left">
				<FormItem label="服务费用:">
					<Input type="number" v-model="fromServer.serverMoney" maxlength="8" :readonly='disabled'></Input>
				</FormItem>
				<FormItem label="说明:">
					<Input class="input" maxlength="50" :rows="3" :readonly='disabled' type="textarea"
						v-model="fromServer.desc" placeholder="请输入简单的标注说明"></Input>
				</FormItem>
				<div class="text-red text-df">
					注意事项：费用支付成功后师傅会收到付款提醒，或者您可以主动告知师傅
				</div>
			</Form>
		</div>
		<div class="btn-grounp" style="padding: 20px;">
			<Form class="form" label-position="top">
				<FormItem label="可用优惠券：" v-if="type!='addMoney'">
					<div class="tab-item" :class="{active:formItem.coupon_id == item.coupon_id}"
						v-for="(item,index) in couponList" :key="index" @click="chooseCoupon(item)">
						优惠 {{ item.reduction_money }}元
					</div>
				</FormItem>
				<FormItem label="支付方式：">
					<tabNav :list="payTypeList" v-model="formItem.method"></tabNav>
				</FormItem>
				<FormItem label="支付密码：" v-if="formItem.method=='balance'">
					<Input type="password" maxlength="6" v-model="formItem.password" class="wn60" hidden
						autocomplete="new-password"></Input>
				</FormItem>
				<div class="footer">
					<Button class="pay-btn" type="primary" @click="payment()" style="width: 100px">立即支付</Button>
				</div>
			</Form>
		</div>
	</div>
</template>

<script>
import { EventBus } from '@/utils/event-bus.js'
import HeaderComponents from '../../../components/header'
import MasterItem from './components/master-item'
import cancelOrder from '../../../components/cancel-order'
import tabNav from '../../../components/tabNav'

export default {
  name: 'order_detail',
  components: {
    HeaderComponents,
    MasterItem,
    tabNav
  },

  activated () {
    let vm = this
    let id = this.$route.params.id
    let addid = this.$route.params.addid || ''
    let money = this.$route.params.money
    let addReason = this.$route.params.addReason
    this.formItem.password = ''
    this.type = this.$route.params.type || ''
    this.isWorkerInscreasePay = String(this.$route.params.fromWorkerInscrease || '') === '1'
    this.disabled = false
    vm.id = id
    vm.addid = addid || ''
    if (money) {
      this.disabled = true
    }
    vm.fromServer.serverMoney = money || ''
    vm.fromServer.desc = addReason || ''
    vm.getpwdInfo()
    vm.getCouponList()
    vm.getDetailInfo()
  },
  data () {
    return {
      formItem: {
        method: 'balance',
        money: '',
        coupon_id: '',
        coupon_price: 0,
        password: ''
      },
      disabled: false, // 是否限制输入
      couponList: [], // 可以优惠券
      fromServer: {
        serverMoney: '',
        desc: ''
      }, // 增加服务费
      all_money: '', //
      payTypeList: [{
        value: 'balance',
        label: '余额支付'
      },
      {
        value: 'wechatpc',
        label: '微信支付'
      },
      {
        value: 'apliypc',
        label: '支付宝支付'
      }
      ],
      step: 1,
      timer: null,
      order_type: 1,
      is_set: '', // 是否设置密码
      type: '', // addMoney 增加费用
      isWorkerInscreasePay: false,
      id: 0, // 订单id
      addid: '', // 增加费用单条id
      worker_id: 0,
      initial_price: 0,
      price: 0,
      offer_data: [],
      offer_all: 0,
      order_no: '',
      status_name: '',
      end_date: '',
      status: 0,
      nickname: '',
      title: '',
      created_at: '',
      logistics: {
        has: true,
        address: '',
        arrive: '',
        freight: 0,
        logistics_number: '',
        package_number: '',
        phone: '',
        company: ''
      },
      other: {
        contact: '',
        hope_complete: ''
      },
      address: {
        name: '',
        address: '',
        floor: '',
        phone: '',
        third: ''
      },
      data: [{
        img: '',
        type: 'AM12312312',
        category: '盖板/普通',
        count: 1,
        sku_name: '嵌入式（壁挂）',
        requirement: '不要敲门',
        install: '需要拆除（玻璃胶）'
      }]
    }
  },
  methods: {
    getCouponList () {
      this.$request('62b430e1cb941', {
        order_id: this.id + ''
      }).then(res => {
        this.couponList = res.data.data
      })
    },
    getpwdInfo () {
      this.$request('62b292c10b427', {}).then(res => {
        this.is_set = res.data.data.status
      })
    },
    getDetailInfo () {
      let vm = this
      this.$request('6120ad9af2b9b', {
        order_id: this.id + '',
        coupon_id: this.formItem.coupon_id
      }).then(res => {
        vm.order_no = res.data.data.base.number
        vm.nickname = res.data.data.base.nickname
        vm.created_at = res.data.data.base.created_at
        vm.status_name = res.data.data.msg
        vm.all_money = res.data.data.all_money
        vm.price = res.data.data.price
        vm.status = res.data.data.status

        if (res.data.data.end_date != '' && res.data.data.end_date != undefined && res.data.data
          .end_date !=
						null) {
          vm.end_date = res.data.data.end_date
        }

        vm.order_type = res.data.data.order_type
        vm.title = res.data.data.title

        vm.address.name = res.data.data.address.name
        vm.address.address = res.data.data.address.address
        vm.address.floor = res.data.data.address.floor
        vm.address.phone = res.data.data.address.phone
        vm.address.third = res.data.data.third

        vm.other.contact = res.data.data.other.contact
        vm.other.hope_complete = res.data.data.other.hope_complete

        if (res.data.data.logistics != null && res.data.data.logistics != undefined && res.data.data
          .logistics !=
						'') {
          vm.logistics.address = res.data.data.logistics.address
          vm.logistics.arrive = res.data.data.logistics.arrive
          vm.logistics.freight = res.data.data.logistics.freight
          vm.logistics.logistics_number = res.data.data.logistics.logistics_number
          vm.logistics.package_number = res.data.data.logistics.package_number
          vm.logistics.company = res.data.data.logistics.company
          vm.logistics.phone = res.data.data.logistics.phone
          vm.logistics.has = true
        } else {
          vm.logistics.has = false
        }
        if (vm.type == 'addMoney' && !vm.addid) {
          vm.setWorkerInscreasePayInfo(res.data.data.order_inscrease)
        }
      })
    },
    setWorkerInscreasePayInfo (orderInscrease) {
      const list = Array.isArray(orderInscrease) ? orderInscrease : []
      const pending = list.find(item => String(item.status) === '0' && String(item.is_refund) === '0') || list[0]
      if (!pending) return
      this.addid = pending.id || ''
      this.fromServer.serverMoney = pending.cost || ''
      this.fromServer.desc = pending.instruction || ''
      this.disabled = true
    },
    chooseCoupon (item) {
      this.formItem.coupon_id = item.coupon_id
      this.formItem.coupon_price = item.reduction_money
      this.getDetailInfo()
    },
    cancel () {
      let vm = this
      this.$cancelOrder({
        id: vm.id
      }).then(res => {
        console.log(res)
        if (res == 'confirm') {
          console.log('----')
          vm.$message.success('操作成功')
          location.reload()
        }
      })
    },
    addMoneyPay () {
      let vm = this
      console.log(vm.formItem.method, 'vm.formItem.method')
      if (vm.formItem.method == 'balance') {
        if (this.is_set == 1) {
          if (!vm.formItem.password) {
            return vm.$message.error('请输入支付密码')
          }
          vm.balancePay()
        } else {
          vm.$message.error('请先设置支付密码')
          setTimeout(() => {
            this.$router.push({
              name: 'user_setPayPassword'
            })
          }, 200)
        }
      } else {
        // 微信支付  支付宝支付
        this.$request('612c887274100', {
          order_id: this.id + '',
          id: this.addid + '', // 单条记录id
          pay_method: vm.formItem.method == 'wechatpc' ? 'wechatpc' : 'alipay',
          instruction: this.fromServer.desc,
          cost: this.fromServer.serverMoney
        }).then(res => {
          // this.$message.success("支付成功")
          // location.reload();
          if (vm.formItem.method == 'wechatpc') {
            let aaa = this.$paymentAlert({
              title: '扫码支付',
              code_url: res.data.data.wechat.code_url,
              text: '订单支付'
            }).then(ress => {
              if (ress == 'cancel') {
                clearInterval(vm.timer)
              }
            })
            // 查询支付状态
            this.timer = setInterval(() => {
              this.$request('619f23ac0f0d0', {
                'order_no': vm.id + '',
                'scene': 'order'
              }).then(resp => {
                if (resp.data.data.status != '0') {
                  clearInterval(vm.timer)
                  this.$message.success('支付成功')
                  // this.$router.go(-1)
                  this.$router.push({
                    	name: 'order_list'
                  })
                  aaa = ''
                }
              })
            }, 2000)
          } else { // 支付宝
            window.open('https://api.yibxj.com/api/payOrderByAlipay?order_no=' + vm.id, '_blank')
            setTimeout(() => {
              this.$confirm('确定支付成功了吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                // this.$router.go(-1)
                this.$router.push({
                  	name: 'order_list',
                  params: { type: 'orderList' }
                })
              }).catch(() => {

              })
            }, 1000)
          }
        })
      }
    },
    // 余额支付
    balancePay () {
      this.$util.throttle(() => {
        this.$request('612c887274100', {
          order_id: this.id + '',
          id: this.addid + '', // 单条记录id
          pay_method: 'balance',
          instruction: this.fromServer.desc,
          cost: this.fromServer.serverMoney,
          password: this.formItem.password
        }).then(res => {
          console.log(res, '余额支付')
          if (res.data.code == 1) {
            this.$message.success('支付成功')
            // this.$router.go(-1)
            this.$router.push({
             	name: 'order_list'
            })

            // location.reload();
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }, 2000, true)
    },
    payment () {
      // EventBus.$emit("aMsgOrder", '通知订单列表刷新');
      // return
      let vm = this
      if (vm.type == 'addMoney') {
        // 增加费用
        if (!vm.fromServer.serverMoney) {
          return vm.$message.error('请输入要增加的费用')
        }
        if (vm.fromServer.serverMoney <= 0) {
          return this.$message.error('请输入正确的费用金额')
        }
        if ((vm.fromServer.serverMoney + '').split('.') && (vm.fromServer.serverMoney + '').split('.')[1] && (
          vm.fromServer.serverMoney + '').split('.')[1].length > 2) {
          return this.$message.error('请输入正确的费用金额')
        }
        if (!vm.fromServer.desc) {
          return vm.$message.error('请简单输入说明')
        }
        vm.addMoneyPay()
      } else {
        // 待支付订单支付
        if (vm.formItem.method == 'balance') {
          if (this.is_set == 1) {
            if (!vm.formItem.password) {
              return vm.$message.error('请输入支付密码')
            }
            this.$request('61244fce74769', {
              'order_id': vm.id + '',
              'pay_method': vm.formItem.method,
              'password': vm.formItem.password,
              coupon_id: vm.formItem.coupon_id || 0
            }).then(res => {
              console.log(res, '余额支付')
              if (res.data.code == 1) {
                vm.$message.success('支付成功')
                // this.$router.go(-1)
                this.$router.push({
                  	name: 'order_list'
                })
              } else {
                vm.$message.error(res.data.msg)
              }
            })
          } else {
            vm.$message.error('请先设置支付密码')
            setTimeout(() => {
              this.$router.push({
                name: 'user_setPayPassword'
              })
            }, 200)
          }
        } else if (vm.formItem.method == 'wechatpc') {
          // 微信支付
          this.$request('61244fce74769', {
            'order_id': vm.id + '',
            'pay_method': vm.formItem.method,
            coupon_id: vm.formItem.coupon_id || 0
          }).then(res => {
            let aaa = this.$paymentAlert({
              title: '扫码支付',
              code_url: res.data.data.wechat.code_url,
              text: '订单支付'
            }).then(ress => {
              console.log(ress)
              if (ress == 'cancel') {
                clearInterval(vm.timer)
              }
            })
            // 查询支付状态
            this.timer = setInterval(() => {
              this.$request('619f23ac0f0d0', {
                'order_no': vm.id + '',
                'scene': 'order'
              }).then(resp => {
                if (resp.data.data.status != '0') {
                  clearInterval(vm.timer)
                  this.$message.success('支付成功')
                  // this.$router.go(-1)
                  this.$router.push({
                    	name: 'order_list'
                  })
                  aaa = ''
                }
              })
            }, 2000)
          })
        } else {
          this.$request('62f9ecf1504fd', {
            'order_no': vm.id + '',
            coupon_id: this.formItem.coupon_id || 0
          }).then(res => {
            // 支付宝支付
            window.open('https://api.yibxj.com/api/payOrderByAlipay?order_no=' + vm.id, '_blank')
            setTimeout(() => {
              this.$confirm('确定支付成功了吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                // this.$router.go(-1)
                this.$router.push({
                  	name: 'order_list'
                })
              }).catch(() => {

              })
            }, 1000)
          })
        }
      }
    },
    gotoPay () {
      console.log('gotoPay')
    }
  }
}
</script>

<style lang="less">
	.order_detail {

		.ivu-steps-title {
			margin-top: 2px;
		}

		.card {
			background-color: #FFFFFF;
			padding: 20px;
			border-radius: 3px;

			.base {
				margin-top: 30px;
				border-radius: 3px;

				.header {
					display: flex;
					justify-content: space-between;

					.left {
						display: flex;
					}

					.status {
						margin-left: 30px;

						.error {
							color: red;
						}
					}

					.right .cancel {
						margin-left: 10px;
					}
				}

				.info {
					margin-top: 10px;

					span {
						margin-right: 40px;
					}
				}
			}

			.title {
				font-size: 18px;
				color: #333;
				font-weight: 450;
				position: relative;

				&::after {
					content: '';
					position: absolute;
					bottom: -10px;
					left: 0;
					width: 70px;
					height: 3px;
					background-color: #FB9E2F;
				}
			}

		}

		.block {
			height: 10px;
			background-color: #f7f8fa;
		}

		.step {
			padding: 20px;

			.title {
				margin-bottom: 15px;
				color: rgb(51, 51, 51);
				font-size: 18px;
				margin-right: 12px;
			}
		}

		.user-info {
			padding: 20px;
		}

		.descriptions-label {
			color: #333333;
		}

		.el-descriptions__title {
			color: rgb(51, 51, 51);
			font-size: 18px;
			font-weight: normal;
		}

		.error {
			color: red;
		}
	}

	.tab-item {
		display: inline-block;
		margin-right: 8px;
		height: 35px;
		padding: 0 15px;
		cursor: pointer;
		background-color: #f7f8fa;
		border-radius: 9px;
		border: none;
		color: rgb(17, 17, 17);
		font-size: 12px;
		line-height: 35px;
	}

	.active {
		color: #FB9E2F;
		font-weight: 500;
		position: relative;

		&::after {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			border: 1px solid #FB9E2F;
			border-radius: 9px;
		}
	}
</style>
